import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.scss';
import EmpFooter from './components/template/emp-footer/emp-footer';
import { EmpLandingNavbar } from './components/template/emp-landing-navbar/emp-landing-navbar';
import EnterpriseInterestPage from './pages/enterprise-interest-page/enterprise-interest-page';
import LandingPage from './pages/landing-page/landing-page';

function App() {

  return (
    <>

      <div className="app-page-wrapper">
        <BrowserRouter>
          <EmpLandingNavbar />
          <Routes>
            <Route path="/" element={<LandingPage />}></Route>
            <Route path="enterprise-interest" element={<EnterpriseInterestPage />}></Route>
          </Routes>
        </BrowserRouter>
        <EmpFooter />
      </div>
    </>
  )
}

export default App;
